import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';

@Component({})
class EdSlider extends Vue {
  @Model('input') readonly value!: number;
  @Prop({ default: 1 }) readonly max: number;
  @Prop({ default: 0 }) readonly min: number;
  @Prop({ type: Array, default: () => [] }) readonly tickLabels!: string[];
  @Prop({ default: 1 }) readonly step!: number;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly stopKeyDown: boolean;

  get modelValue() {
    return this.value;
  }

  set modelValue(val: number) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  get range(): number {
    return this.max - this.min;
  }

  get hasNumericLabels(): boolean {
    return this.tickLabels.some(tick => this._isNumericLabel(tick));
  }

  get unitPercentage(): number {
    return ((1 - this.min) / this.range) * 100;
  }

  private _isNumericLabel(value: any | undefined): boolean {
    if (!value) return false;
    return Number.isFinite(Number(value));
  }

  getThumbPosition(value: number): string {
    const range = this.range;

    if(range == 0) return '0px';

    const percent = ((value - this.min) / range) * 100;

    return `${percent}%`;
  }

  getTickPosition(index: number): string {
    if (this.tickLabels.length <= 1) return '0%';

    const percent = (index / (this.tickLabels.length - 1)) * 100;
    return `${percent}%`;
  }

  getTickStyle(index: number): any {
    if (this.hasNumericLabels) {
      return {};
    }

    const isFirst = index === 0;
    const isLast = index === this.max;

    return {
      width: (isFirst || isLast) ? `${this.unitPercentage / 2}%` : `${this.unitPercentage}%`,
      textAlign: isFirst ? 'start' : isLast ? 'end' : 'center',
    };
  }

  onKeyDown(event: KeyboardEvent) {
    if (this.stopKeyDown) {
      event.stopPropagation();
    }
  }
}

export default Vue.component('ed-slider', EdSlider);
